"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mui = require("tss-react/mui");
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Link = _interopRequireDefault(require("../Link"));
var _excluded = ["className", "message", "to", "linkMessage", "color"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
// TODO jss-to-tss-react codemod: Unable to handle style definition reliably.
// ArrowFunctionExpression in CSS prop.
var useStyles = (0, _mui.makeStyles)()(function (theme) {
  return {
    root: {
      textAlign: function textAlign(_ref) {
        var _textAlign = _ref.textAlign;
        return _textAlign;
      },
      color: theme.palette.darkGrey.light
    },
    link: {
      fontWeight: 'bold'
    }
  };
});
var MessageWithLink = function MessageWithLink(_ref2) {
  var className = _ref2.className,
    message = _ref2.message,
    to = _ref2.to,
    linkMessage = _ref2.linkMessage,
    color = _ref2.color,
    TypographyProps = _objectWithoutProperties(_ref2, _excluded);
  var _useStyles = useStyles(),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  return /*#__PURE__*/_react["default"].createElement(_Typography["default"], _extends({
    className: cx(classes.root, className)
  }, TypographyProps), message, "\xA0", /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    className: classes.link,
    to: to,
    color: color,
    variant: "body1",
    underline: "none"
  }, linkMessage));
};
MessageWithLink.propTypes = {
  className: _propTypes["default"].string,
  message: _propTypes["default"].string.isRequired,
  to: _propTypes["default"].string.isRequired,
  linkMessage: _propTypes["default"].string.isRequired,
  color: _propTypes["default"].oneOf(['default', 'error', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary'])
};
MessageWithLink.defaultProps = {
  className: undefined,
  color: 'primary'
};
var _default = MessageWithLink;
exports["default"] = _default;